<script lang="ts">
  import type { SvelteHTMLElements } from 'svelte/elements'

  type Props = {
    color?: string
  } & SvelteHTMLElements['svg']

  let { color = 'currentColor', ...restProps }: Props = $props()
</script>

<svg viewBox="360 300 480 600" xmlns="http://www.w3.org/2000/svg" {...restProps}>
  <path
    d="m705.09 816.29c-7.8828 2.4219-15.883 4.2812-23.91 5.668l-35.809 65.211h98.66zm-198.64-95.824c50.539 73.152 148.9 96.293 226.75 50.863 77.848-45.461 107.22-143.2 69.816-224.03zm90.625-87.852 85.434-49.859-87.109-52.84zm-16.324-173.7c-6.1992-10.832-19.926-14.555-30.641-8.2969s-14.375 20.133-8.207 30.969c6.1992 10.832 19.895 14.555 30.613 8.2969 10.746-6.2578 14.406-20.133 8.2344-30.969z"
    fill={color}
    fill-rule="evenodd"
  />

  <path
    d="m429.73 497.92c24.414-93.348 116.02-150.37 206.55-128.05l4.3086 1.1211 1.4453 0.47266c7.0859 2.7461 11.102 10.539 9.0625 18.066-2.0352 7.5586-9.3594 12.223-16.855 10.953l-1.4766-0.32422-3.543-0.91406c-74.035-18.242-150.14 28.25-170.59 106.39-2.0977 8.0586-10.273 12.871-18.242 10.746-8-2.125-12.754-10.391-10.656-18.449z"
    fill={color}
  />

  <path
    d="m382.91 478.91c34.301-119.26 154.07-190.46 270.88-158.41 7.9688 2.1836 12.664 10.508 10.508 18.566-2.1562 8.0312-10.363 12.812-18.332 10.625-101.87-27.957-207.67 35.363-235.71 142.64l-0.47266 1.4766c-2.6562 7.1719-10.301 11.277-17.801 9.2695-7.9688-2.125-12.754-10.391-10.625-18.48z"
    fill={color}
  />
</svg>
